import { getToken } from '../utils/authStorage'

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000').replace(/\/$/, '')
// const PKG = 'jumpjump'
const PKG = 'tripeaks'

interface ApiEnvelope<T> {
  code: number
  data: T
  msg?: string
}

function isSuccessCode(code: unknown): boolean {
  return Number(code) === 200
}

export async function apiRequest<T>(
  endpoint: string,
  options: { method?: string; body?: Record<string, unknown> } = {}
): Promise<T> {
  const method = options.method ?? 'GET'
  const token = getToken()
  const payload = { pkg: PKG, ...options.body }

  const headers: Record<string, string> = {}
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  let url = `${API_BASE_URL}/${endpoint.replace(/^\//, '')}`
  const init: RequestInit = { method, headers }

  if (method === 'POST') {
    headers['Content-Type'] = 'application/json'
    init.body = JSON.stringify(payload)
  } else {
    const query = new URLSearchParams(
      Object.fromEntries(Object.entries(payload).map(([key, value]) => [key, String(value)]))
    )
    url = `${url}?${query}`
  }

  const response = await fetch(url, init)

  const result = (await response.json()) as ApiEnvelope<T>
  if (isSuccessCode(result.code)) {
    return result.data
  }
  throw new Error(result.msg || 'Request failed')
}
